export default {
  install(Vue, options) {
    Vue.prototype.$c = {};

    if (console) {
      let m,
        preventLogging = !options || !options.debugMode;
      for (m in console) {
        if (typeof console[m] === "function")
          Vue.prototype.$c[m] = preventLogging
            ? function() {}
            : console[m].bind(window.console);
      }
    }
  }
};
